<template>
	<LazyHydrate when-visible>
		<layoutSection class="rounded-GO tablet:rounded-tr-none bg-goPinkBrighter ">
			<div class="p-16 tablet:p-48 desktop:p-56 desktopWide:px-0 tabletWide:w-10/12 desktop:w-full">
				<div class="space-y-56">
					<h2 class="font-bold text-32 tablet:text-40 desktop:text-48">{{ title }}</h2>
					<ul class="tablet:text-14 desktop:text-16 grid grid-cols-1 tablet:grid-cols-2 tabletWide:grid-cols-3 desktop:grid-cols-5 gap-24 tabletWide:gap-y-32">
						<li v-for="item in list" :key="item.icon" class="flex flex-col space-y-16">
							<svg-icon :name="item.icon" class="iconSize-32 text-goPink" />
							<p class="font-bold">{{ item.title }}</p>
							<p v-html="item.text" />
						</li>
					</ul>
					<div class="tablet:text-14 leading-24">
						<nuxt-link to="/about-us/why-choose-go/" class="button button-normal button-goPinkGhost">Learn more</nuxt-link>
					</div>
				</div>
			</div>
		</layoutSection>
	</LazyHydrate>
</template>

<script>
import layoutSection from '~/components/layoutSection.vue'

export default {
	components: {
		layoutSection
	},
	props: {
		title: {
			type: String,
			default: "Why GO with us?",
		}
	},
	data() {
		return {
			list: [
				{
					icon: 'insurance',
					title: 'FREE basic car rental insurance',
					text: 'Our basic insurance cover is included in the cost of every car hire with two upgraded <a class="link link-goBlue font-bold" href="/services/rental-car-insurance/">insurance options</a> available!'
				},
				{
					icon: 'arrow-forward',
					title: 'One-way car rentals',
					text: 'We can organise <a class="link link-goBlue font-bold" href="/services/one-way-car-rental/">one-way rentals</a> with pick-up in one location and drop-off in another. Stick to your dream itinerary without worrying about circling back.'
				},
				{
					icon: 'leaf',
					title: 'Offset carbon emissions',
					text: 'In partnership with <a class="link link-goBlue font-bold" href="/go-zero/">CarbonClick</a>, you can choose to offset the carbon emission of your GO Rentals road trip.'
				},
				{
					icon: 'road-assistance',
					title: '24hr AA roadside assistance',
					text: 'All GO Rentals hire cars have access to the AA 24-hour mechanical breakdown assistance and our Tesla EVs have access to Tesla Roadside Assistance.'
				},
				{
					icon: 'app-outline',
					title: 'GO App',
					text: 'With our <a class="link link-goBlue font-bold" href="/app/">GO Rentals App</a>, you can book a car, check in faster and even control your Tesla car functions, right from the palm of your hand.'
				},
			],
		}
	}
}
</script>
